import React from 'react';
import { createUseStyles } from 'react-jss';
import Button from '../../elements/Button';

interface DialogFooterProps {
  onClose: () => void;
}

const DialogFooter = ({ onClose }: DialogFooterProps) => {
  const classes = useStyles();

  return (
    <div className={classes.footerContainer}>
      <Button variant="primary" onClick={onClose}>
        Schließen
      </Button>
    </div>
  );
};

const useStyles = createUseStyles({
  footerContainer: {
    paddingLeft: 32,
    paddingRight: 32,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
});

export default DialogFooter;
